import React from 'react';
import { privateRoutes } from '../routes';
import SidebarLinks from './SidebarLinks';
import { Backdrop, Drawer } from './style';

interface SidebarElement {
    handleDrawerClose(): void;
    handleDrawerOpen(): void;
    isDrawerOpen: boolean;
}

const SidebarElement = ({ handleDrawerClose, isDrawerOpen, handleDrawerOpen }: SidebarElement) => {
    return (
        <>
            <Drawer
                variant="permanent"
                open={isDrawerOpen}
            >
                <SidebarLinks
                    isDrawerOpen={isDrawerOpen}
                    routes={privateRoutes}
                    onClick={handleDrawerClose}
                    onCollapsibleClick={handleDrawerOpen}
                />
            </Drawer>
            <Backdrop
                open={isDrawerOpen}
                onClick={handleDrawerClose}
            />
        </>
    );
};

export default SidebarElement;
